import { type ReactNode } from 'react'

interface ErrorMessageProps {
  title: string
  message: string | ReactNode
  children?: ReactNode
  onDismiss?: () => void
}

export function ErrorMessage({ title, message, children, onDismiss }: ErrorMessageProps) {
  return (
    <div className="h-full w-full">
      <div className="flex h-full w-full flex-col items-center justify-center rounded-lg border border-slate-200 p-8 text-center">
        <svg className="mx-auto mb-4 h-16 w-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 className="mb-2 text-xl font-semibold">{title}</h2>
        <div className="mb-6">{message}</div>
        {children}
        {onDismiss && (
          <button onClick={onDismiss} className="mt-4 text-sm text-slate-600 hover:text-slate-900">
            Zavřít
          </button>
        )}
      </div>
    </div>
  )
}
